/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const SpeechToText = defineMessages({
  title: {
    id: 'phone.SpeechToText.title',
    defaultMessage: 'Speech to Text'
  },
  description: {
    id: 'phone.SpeechToText.description',
    defaultMessage:
      'Configure the Speech to Text services that will be used by the phone integration. <link>Learn more</link>'
  },
  stepDescription: {
    id: 'phone.SpeechToText.stepDescription',
    defaultMessage:
      'Use the recommended default values, or choose your own Speech to Text services that will be used by the phone integration. <link>Learn more</link>'
  },
  instanceSubtitle: {
    id: 'phone.SpeechToText.instanceSubtitle',
    defaultMessage: 'Speech to Text instance'
  },
  instanceDescription: {
    id: 'phone.SpeechToText.instanceDescription',
    defaultMessage:
      'Select an instance to use with your phone integration automatically.'
  },
  filterModel: {
    id: 'phone.SpeechToText.filterModel',
    defaultMessage: 'Filter models based on your assistant language'
  },
  filterWarning: {
    id: 'phone.SpeechToText.filterWarning',
    defaultMessage: 'Turning this off can cause model mismatching'
  },
  languageModel: {
    id: 'phone.SpeechToText.languageModel',
    defaultMessage: 'Choose your Speech to Text language model'
  },
  languageDescription: {
    id: 'phone.SpeechToText.languageDescription',
    defaultMessage: 'This model transcribes incoming calls to text'
  },
  sttModelLabel: {
    id: 'phone.SpeechToText.sttModelLabel',
    defaultMessage: 'Base language model to transcribe incoming calls to text'
  },
  sttCustomLanguageModelLabel: {
    id: 'phone.SpeechToText.sttCustomLanguageModelLabel',
    defaultMessage: 'Custom language model'
  },
  sttCustomAcousticModelLabel: {
    id: 'phone.SpeechToText.sttCustomAcousticModelLabel',
    defaultMessage: 'Custom acoustic model'
  },
  sttDeprecationTitle: {
    id: 'phone.SpeechToText.sttDeprecationTitle',
    defaultMessage: 'Next-gen speech models available'
  },
  sttDeprecationText: {
    id: 'phone.SpeechToText.sttDeprecationText',
    defaultMessage:
      'Starting August 1, 2023, all previous-generation models are now discontinued from the service. New clients must now only use the next-generation models. All existing clients must now migrate to the equivalent next-generation model. <link>Learn more</link>.'
  },
  customModelHelperText: {
    id: 'phone.SpeechToText.customModelHelperText',
    defaultMessage: 'This will override the language base model when selected'
  },
  learnMoreLinkStt: {
    id: 'phone.SpeechToText.learnMoreLinkStt',
    defaultMessage: 'Learn more about Speech to Text'
  },
  createMessage: {
    id: 'phone.SpeechToText.createMessage',
    defaultMessage:
      'A Speech to Text instance is required to set up a phone integration. By default, the speech service plan will be matched with your {productName} plan. You will not be billed separately for service usage from phone calls. Beyond this integration, any added usage of these speech services will result in separate charges.'
  },
  instanceId: {
    id: 'phone.SpeechToText.instanceIdL',
    defaultMessage: 'Speech to Text instance ID'
  },
  bearerToken: {
    id: 'phone.SpeechToText.bearerToken',
    defaultMessage: 'Bearer Token'
  }
});
